import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CoreModule } from '@core/core.module';
import { API_URL, ENV, SERVER_URL, WEB_SOCKET_URL } from '@core/core.tokens';
import { RestErrorAuthInterceptor } from '@core/interceptors/rest-error-auth.interceptor';
import { TokenInterceptor } from '@core/interceptors/token.interceptor';
import { getWebSocketUrl } from '@core/services/get-web-socket-url.factory';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoService } from '@ngneat/transloco';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { ToastContainerModule, ToastrModule } from 'ngx-toastr';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { LoadingPanelInterceptor } from './modules/loading-panel/loading-panel.interceptor';
import { LoadingPanelModule } from './modules/loading-panel/loading-panel.module';
import { AppRoutingModule } from './routing/app-routing.module';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { CustomPaginatorIntl } from './utils/custom-paginator-intl/custom-paginator-intl';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslocoRootModule,

    // toastr
    ToastrModule.forRoot({
      maxOpened: 5,
      enableHtml: true,
      positionClass: 'toast-bottom-right',
    }),
    ToastContainerModule,

    MonacoEditorModule.forRoot(),

    CoreModule,
    LoadingPanelModule.forRoot(),

    // ngrx
    StoreModule.forRoot({}, {}),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    EffectsModule.forRoot([]),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    FontAwesomeModule
  ],
  providers: [
    { provide: ENV, useValue: environment },
    { provide: API_URL, useValue: environment.apiUrl },
    { provide: SERVER_URL, useValue: environment.serverUrl },
    { provide: WEB_SOCKET_URL, useFactory: getWebSocketUrl, deps: [ENV] },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RestErrorAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingPanelInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl, deps: [TranslocoService] },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY',
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'DD/MM/YYYY',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      }
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
